import { Redirect } from 'expo-router';

import { ROUTES } from '@/constants/routes';

/** Sends a direct link to the old invite tab to the account invite screen that replaced it. */
export default function InvitesRedirect() {
  return <Redirect href={ROUTES.ACCOUNT_INVITES} />;
}
